import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-tipo-caracteristica',
  templateUrl: './btn-nuevo-tipo-caracteristica.component.html',
  styleUrls: ['./btn-nuevo-tipo-caracteristica.component.css']
})
export class BtnNuevoTipoCaracteristicaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
